import { AppTheme } from '../theme'

export type FontSize = keyof AppTheme['fontSizes']
type FontColor = keyof AppTheme['colors']['text']
type FontFamily = keyof AppTheme['fontFamily']

export const getLineHeightPx = (size: FontSize): number => {
    switch (size) {
        case 'header':
            return 36
        case 'title':
            return 32
        case 'label':
            return 24
        case 'sub':
            return 21
        default:
            return 27
    }
}

const getWeight = (size: FontSize): number => {
    switch (size) {
        case 'header':
        case 'title':
            return 400
        default:
            return 300
    }
}

export const textSizes = {
    paragraph: ({ theme }: { theme: AppTheme }): string => theme.fontSizes.paragraph,
    title: ({ theme }: { theme: AppTheme }): string => theme.fontSizes.title,
}

export const textLineHeights = {
    paragraph: (): string => `${getLineHeightPx('paragraph')}px`,
    title: (): string => `${getLineHeightPx('title')}px`,
}

export const text =
    (
        size: FontSize = 'paragraph',
        color: FontColor = 'primary',
        family: FontFamily = 'text',
        weight?: 'default' | 'bold' | 'heavy'
    ) =>
    ({ theme }: { theme: AppTheme }): string => {
        const lineHeightPx = getLineHeightPx(size)

        let fontWeight = getWeight(size)
        if (weight === 'bold') fontWeight = 400
        if (weight === 'default') fontWeight = 300
        if (weight === 'heavy') fontWeight = 500
        return `
        color: ${theme.colors.text[color]};
        font-size: ${theme.fontSizes[size]};
        font-family: ${theme.fontFamily[family]};
        line-height: ${lineHeightPx}px;
        font-weight: ${fontWeight};
    `
    }
